module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "birthday"
  }, [_c('div', {
    staticClass: "discount_bg"
  }, [_c('img', {
    staticClass: "birth_usebtn",
    attrs: {
      "src": require("./../../image/scflow/birth_usebtn.png")
    },
    on: {
      "click": function($event) {
        return _vm.usebirCount()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "price"
  }, [_vm._v("满" + _vm._s(_vm.birthdayObj.data.mininum) + "减" + _vm._s(_vm.birthdayObj.data.amount))]), _vm._v(" "), _c('img', {
    staticClass: "close",
    attrs: {
      "src": require("./../../image/scflow/close.png")
    },
    on: {
      "click": function($event) {
        return _vm.closeBirth()
      }
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c69d552c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c69d552c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!(webpack)-px-to-rem?{"basePx":75,"min":1}!./src/common/components/birthdayComponent.vue
// module id = 422
// module chunks = 32